<template>
  <div class="crud-services">
    <b-card body-class="py-2">
      <section class="list-view-heading">
        <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
        <div class="list-view-heading__controls">
          <div class="list-view-heading__actions"><TabHeaderActions /></div>
          <div class="list-view-heading__controls-end">
            <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
            <b-button @click="add" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar servicio" aria-label="Agregar servicio"><AppIcon name="add" /></b-button>
          </div>
        </div>
      </section>
      <b-collapse v-model="filtersOpen">
        <div class="list-view-toolbar__filters">
          <div class="list-view-filter" style="width: 260px;"><label class="filter-label">Categorías</label><v-select :options="arr.filter.category" v-model="filter.category" placeholder="Todas" :multiple="true" :select-on-tab="true" /></div>
          <div class="list-view-filter" style="width: 170px;"><label class="filter-label">Estado</label><v-select :options="arr.filter.status" v-model="filter.status" placeholder="Activos" :multiple="true" :select-on-tab="true" /></div>
          <b-button variant="outline-dark" size="sm" @click="filterService()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;"><AppIcon name="filter" /></b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-card no-body class="mt-2">
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark" class="crud-services-tabs">
          <b-tab active><template #title><AppIcon name="design_services" class="mr-1" /> En servicios</template>
            <b-row>
              <b-col>
                <b-table class="mb-0 app-table"
                        responsive
                        sticky-header="60vh"
                        :hover="true"
                        :stacked="isMobileViewport ? 'md' : false"
                        :fixed="!isMobileViewport"
                        :items="table.items"
                        :fields="table.fields"                    
                        :current-page="table.currentPage"
                        :per-page="table.perPage"  
                        :busy="table.isBusy"                                      
                        v-if="table.items.length || table.isBusy">                                           

                    <template v-slot:table-colgroup="scope"><col v-for="field in scope.fields" :key="field.key" :style="{ width: field.width }"></template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <b>{{data.item.id}}</b>
                    </template>

                    <template v-slot:cell(category)="data">
                      <span v-b-tooltip.hover :title="data.item.category.name">{{data.item.category.name}}</span>
                    </template>

                    <template v-slot:cell(name)="data">                  
                      <div class="crud-services-name" v-b-tooltip.hover :title="data.item.name">
                        <span v-if="data.item.code" class="crud-table-service-code">
                          {{data.item.code}}<br>                   
                        </span>
                        {{data.item.name}}
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">                      
                      <span v-if="data.item.observations">                                                    
                        <b-badge variant="primary" :id="'popover-service-observations-' + data.item.id" class="popover-observations">
                          <AppIcon name="notes"></AppIcon>
                        </b-badge>
                        <b-popover :target="'popover-service-observations-' + data.item.id" variant="default" triggers="hover">                            
                          <div v-html="data.item.observations.replace(/\n/g, '<br>')"></div>
                        </b-popover>                                                    
                      </span>                          
                    </template>                    

                    <template v-slot:cell(mode)="data">
                      <div v-html="getModeName(data.item.mode)"></div>
                    </template>                

                    <template v-slot:cell(renewal)="data">
                      <div v-if="data.item.mode=='days' || data.item.mode=='months' || data.item.mode=='years'">
                        <div class="crud-services-renewal" v-b-tooltip.hover :title="'Renovación ' + (data.item.automatic_renewal ? 'automática' : 'manual') + ' cada ' + data.item.renewal + ' ' + getModeName(data.item.mode)">
                          <span class="crud-services-renewal__amount">Cada {{ data.item.renewal }} {{ getModeName(data.item.mode).toLowerCase() }}</span>
                          <span class="crud-services-renewal__type" :class="data.item.automatic_renewal ? 'crud-services-renewal__type--auto' : 'crud-services-renewal__type--manual'"><AppIcon :name="data.item.automatic_renewal ? 'autorenew' : 'sync'" /> Renovación {{ data.item.automatic_renewal ? 'automática' : 'manual' }}</span>
                        </div>
                        <span v-if="data.item.require_purchase_voucher" class="crud-services-renewal__voucher" v-b-tooltip.hover title="La renovación requiere un comprobante de compra cargado"><AppIcon name="receipt" /> Requiere comprobante de compra</span>
                      </div>
                      <div v-else>
                        -
                      </div>                  
                    </template>   

                    <template v-slot:cell(prices)="data">                               
                      <div v-if="data.item.prices.length<3" class="crud-services-prices">
                        <div v-for="element in data.item.prices" :key="element.id">                      
                          <div v-if="element.list">
                            <b :title="element.list.name" v-b-tooltip.hover class="crud-services-prices__list">
                              <span v-if="element.list.reference">
                                {{element.list.reference.substring(0,5)}}
                              </span>
                              <span v-else>
                                {{element.list.name.substring(0,5)}}
                              </span>                              
                            </b>
                            <span>{{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}</span>
                          </div>                      
                        </div>
                      </div>
                      <div v-else>
                        <b-button variant="link" size="sm" class="crud-services-prices__more" @click="setPricesServices(data.item)"><AppIcon name="payments" class="mr-1" />{{ data.item.prices.length }} listas</b-button>
                      </div>
                    </template>

                    <template v-slot:cell(mode_projects)="data">                    
                      <span v-if="data.item.mode_projects == 'with_expiration'" class="crud-services-table-project">
                          <AppIcon name="calendar_month" v-b-tooltip.hover title="Crea proyecto con vencimiento" />
                      </span>  
                      <span v-if="data.item.mode_projects == 'without_expiration'" class="crud-services-table-project">
                          <AppIcon name="refresh" v-b-tooltip.hover title="Crea proyecto sin vencimiento" />
                      </span>                    
                    </template>

                    <template v-slot:cell(instances)="data">
                      <div v-if="isProcessInstances && linkType(data.item) == 'server'">
                        <span class="crud-services-instance crud-services-instance--server" v-b-tooltip.hover title="Se vincula a servidores">
                          <AppIcon name="dns" />
                          Servidor
                        </span>
                      </div>
                      <div v-else-if="isProcessInstances && linkType(data.item) == 'instance'">
                        <span class="crud-services-instance crud-services-instance--linkable" v-b-tooltip.hover title="Se vincula a instancias (Zyncro, Laravel o Docker)">
                          <AppIcon name="deployed_code" />
                          Instancia
                        </span>
                      </div>           
                    </template>

                    <template v-slot:cell(active)="data">
                      <b-badge variant="success" v-if="data.item.active">SI</b-badge>
                      <b-badge variant="danger" v-else>NO</b-badge>
                    </template>                   

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'crud-services-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                        <b-dropdown-item @click="setPricesServices(data.item)" v-if="modules.showPrices">
                          <AppIcon name="payments" class="mr-1" /> Precios
                        </b-dropdown-item>            

                        <b-dropdown-header v-if="isProcessSales">Presupuesto</b-dropdown-header>                         
                        <b-dropdown-item @click="setTemplate(data.item)" v-if="isProcessSales">
                          <AppIcon name="description" class="mr-1" /> Plantilla
                        </b-dropdown-item>                           

                        <b-dropdown-header>Acciones</b-dropdown-header>                         
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" class="mr-1" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)">
                          <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="design_services" title="No se encontraron servicios" />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab><template #title><AppIcon name="inventory_2" class="mr-1" /> Solo en ERP</template>
            <b-row>
              <b-col>
                <b-table class="mb-0 app-table"
                        responsive
                        sticky-header="60vh"
                        :hover="true"
                        :stacked="isMobileViewport ? 'md' : false"
                        :fixed="!isMobileViewport"
                        :items="tableERP.items"
                        :fields="tableERP.fields"                    
                        :current-page="tableERP.currentPage"
                        :per-page="tableERP.perPage"  
                        :busy="tableERP.isBusy"                                      
                        v-if="tableERP.items.length || tableERP.isBusy">                                           

                    <template v-slot:table-colgroup="scope"><col v-for="field in scope.fields" :key="field.key" :style="{ width: field.width }"></template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <b>{{data.item.id}}</b>
                    </template>

                    <template v-slot:cell(category)="data">
                      <span v-b-tooltip.hover :title="data.item.category.name">{{data.item.category.name}}</span>
                    </template>

                    <template v-slot:cell(name)="data">
                      <div class="crud-services-name" v-b-tooltip.hover :title="data.item.name">
                        <span v-if="data.item.code" class="crud-table-service-code">
                          {{data.item.code}}<br>                   
                        </span>
                        {{data.item.name}}
                      </div>
                    </template>                

                    <template v-slot:cell(observations)="data">                      
                      <span v-if="data.item.observations">                                                    
                        <b-badge variant="primary" :id="'popover-erp-observations-' + data.item.id" class="popover-observations">
                          <AppIcon name="notes"></AppIcon>
                        </b-badge>
                        <b-popover :target="'popover-erp-observations-' + data.item.id" variant="default" triggers="hover">                            
                          <div v-html="data.item.observations.replace(/\n/g, '<br>')"></div>
                        </b-popover>                                                    
                      </span>                          
                    </template>                        

                    <template v-slot:cell(prices)="data">                               
                      <div v-if="data.item.prices.length<3" class="crud-services-prices">
                        <div v-for="element in data.item.prices" :key="element.id">                      
                          <div v-if="element.list">
                            <b :title="element.list.name" v-b-tooltip.hover class="crud-services-prices__list">
                              <span v-if="element.list.reference">
                                {{element.list.reference.substring(0,5)}}
                              </span>
                              <span v-else>
                                {{element.list.name.substring(0,5)}}
                              </span>                              
                            </b>
                            <span>{{Intl.NumberFormat('es-AR',{style:'currency',currency:element.list.currency.code}).format(element.amount_total)}}</span>
                          </div>                      
                        </div>
                      </div>
                      <div v-else>
                        <b-button variant="link" size="sm" class="crud-services-prices__more" @click="setPricesServices(data.item)"><AppIcon name="payments" class="mr-1" />{{ data.item.prices.length }} listas</b-button>
                      </div>
                    </template>
                                      
                    <template v-slot:cell(active)="data">
                      <b-badge variant="success" v-if="data.item.active">SI</b-badge>
                      <b-badge variant="danger" v-else>NO</b-badge>
                    </template>                   

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'crud-services-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                        <b-dropdown-item @click="setPricesServices(data.item)" v-if="modules.showPrices">
                          <AppIcon name="payments" class="mr-1" /> Precios
                        </b-dropdown-item>            

                        <b-dropdown-header v-if="isProcessSales">Presupuesto</b-dropdown-header>                         
                        <b-dropdown-item @click="setTemplate(data.item)" v-if="isProcessSales">
                          <AppIcon name="description" class="mr-1" /> Plantilla
                        </b-dropdown-item>                                    

                        <b-dropdown-header>Acciones</b-dropdown-header>                         
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" class="mr-1" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)">
                          <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="inventory_2" title="No se encontraron servicios ERP" />
              </b-col>
            </b-row>            
          </b-tab>
        </b-tabs>        
      </b-card>

      <b-card body-class="py-2" class="mt-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" /> Volver
          </b-button>
          <nav v-if="table.tablePaginate">
            <b-pagination class="mb-0"
                          size="sm"
                          pills=""
                          :total-rows="table.tablePaginate.total"
                          :per-page="table.tablePaginate.per_page"
                          v-model="table.currentPage"
                          @input="filterService()" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="lg"
              body-class="crud-services-modal-body"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon :name="crud.form.id ? 'edit' : 'add'" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div></template>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab no-body><template #title><AppIcon name="settings" class="mr-1" /> General</template>
            <b-row>
              <b-col md="6">
                <b-form-group label="Estado" class="crud-services-switch-field">
                <b-form-checkbox v-model="crud.form.active" 
                                  switch 
                                  size="sm">
                  Activar
                </b-form-checkbox>
                </b-form-group>
              </b-col>      

              <b-col md="6">
                <b-form-group label="Disponibilidad" class="crud-services-switch-field" description="Este servicio solo estará disponible en el módulo ERP.">
                <b-form-checkbox v-model="crud.form.show_only_erp" 
                                  switch                                  
                                  size="sm">
                  Utilizar solo en ERP
                </b-form-checkbox>
                </b-form-group>
              </b-col>                    

              <b-col md="12">
                <b-form-group label="Código" class="crud-services-form-field">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.code"
                                required
                                placeholder="Ingresar un código">
                  </b-form-input>
                </b-form-group>
              </b-col>         

              <b-col md="12">
                <b-form-group label="Nombre" class="crud-services-form-field">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre">
                  </b-form-input>
                </b-form-group>
              </b-col>         

              <b-col md="12">
                <FindObject render="search"
                            type="servicesCategory" 
                            @select-object="loadCategory($event)" 
                            :valueID="crud.form.category_id"/>                 
              </b-col>                            
            </b-row>
          </b-tab>

          <b-tab no-body v-if="!crud.form.show_only_erp"><template #title><AppIcon name="straighten" class="mr-1" /> Medición</template>
            <b-row>
              <b-col md="6">
                <b-form-group label="Medición"
                              description="El precio es aplicado según la medición seleccionada.">
                  <b-form-select v-model="crud.form.mode" 
                                :options="arr.select.mode"
                                stacked
                                @input="changeMode()">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="6" v-if="crud.form.mode == 'days' || crud.form.mode == 'months' || crud.form.mode == 'years'">
                <b-form-group label="Renovación" 
                              :description="'Cantidad de ' + this.getModeName(this.crud.form.mode) + ' para renovar el servicio. Si la renovación es cero (0), el sistema no calcula la renovación para el item'">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.renewal"
                                required
                                min="0"                          
                                placeholder="Ingresar días de renovación">
                  </b-form-input>
                </b-form-group>
              </b-col>


              <b-col md="12" v-if="crud.form.mode == 'days' || crud.form.mode == 'months' || crud.form.mode == 'years'">
                <b-form-checkbox v-model="crud.form.automatic_renewal" 
                                  switch 
                                  size="sm" 
                                  class="pull-left">
                  Renovación Automática
                </b-form-checkbox>            
              </b-col>      

              <b-col md="12" class="mt-2" v-if="crud.form.mode == 'days' || crud.form.mode == 'months' || crud.form.mode == 'years'">
                <b-form-checkbox v-model="crud.form.require_purchase_voucher" 
                                  switch 
                                  size="sm">
                  Requiere comprobante de compra para la renovación
                </b-form-checkbox>
                <small class="text-muted d-block">La renovación tiene que estar respaldada por un comprobante de compra cargado.</small>
              </b-col>      
            </b-row>
          </b-tab>

          <b-tab no-body v-if="isProcessProject && !crud.form.show_only_erp"><template #title><AppIcon name="assignment" class="mr-1" /> Proyecto</template>
            <b-row>
              <b-col md="12">
                  <b-form-group label="Proyecto"
                                description="Crea proyecto a partir del alta del servicio a un cliente.">
                    <b-form-select v-model="crud.form.mode_projects" 
                                  :options="arr.select.modeProjects"
                                  stacked>
                    </b-form-select>
                  </b-form-group>
                </b-col>          
            </b-row>
          </b-tab>

          <b-tab no-body v-if="isProcessInstances && !crud.form.show_only_erp"><template #title><AppIcon name="link" class="mr-1" /> Vinculación</template>
            <b-row>
              <b-col md="12">
                  <b-form-group label="Vinculación"
                                description="A qué se puede asignar el servicio contratado por un cliente.">
                    <b-form-radio-group v-model="crud.form.type_instances"
                                        :options="arr.select.linkTypes"
                                        stacked>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>          
            </b-row>
          </b-tab>  

          <b-tab no-body v-if="isProcessSales"><template #title><AppIcon name="receipt_long" class="mr-1" /> Fiscal</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Detalle para comprobante de venta">
                  <app-textarea  rows="3"                                     
                                    size="sm"
                                    no-resize
                                    v-model="crud.form.display_sales_detail"
                                    required
                                    placeholder="Ingresar un detalle">
                  </app-textarea>
                </b-form-group>
              </b-col>     

              <b-col lg="12">
                <FindObject render="search"
                            type="erpIvaConditions" 
                            @select-object="loadIvaConditions($event)" 
                            :valueID="crud.form.erp_iva_condition_id"/>                   
              </b-col>              
            </b-row>            
          </b-tab>       

          <b-tab no-body v-if="isProcessAccounting"><template #title><AppIcon name="account_balance" class="mr-1" /> Cuenta contable</template>
            <b-row>
              <b-col lg="12">
                <FindObject render="search"
                        type="accountingAccountsImputation" 
                        @select-object="loadAccountingAccounts($event)" 
                        :valueID="crud.form.accounting_accounts_id"
                        :where="conditionAccountingAccountsFilters"/>
              </b-col>              
            </b-row>            
          </b-tab>     

          <b-tab no-body><template #title><AppIcon name="notes" class="mr-1" /> Observaciones</template>
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea  rows="12"                                     
                                    size="sm"
                                    no-resize
                                    v-model="crud.form.observations"
                                    required
                                    placeholder="Ingresar una observacion">
                  </app-textarea>
                </b-form-group>
              </b-col>     
            </b-row>            
          </b-tab>    
        </b-tabs>      
 
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD PRECIOS -->
      <b-modal  v-model="modal.formPrice.active"
                body-class="crud-services-modal-body">
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="payments" /></span><h5 class="app-modal-header__title">{{ modal.formPrice.title }}</h5></div></template>

        <b-row>         
          <b-col md="12">
            <div class="crud-services-title" v-if="itemSelected">
              <div class="crud-services-title">
                <span v-if="itemSelected.code" class="crud-services-code">
                  {{this.itemSelected.code}} 
                </span><br>
                {{this.itemSelected.name}}
              </div>
              <div class="crud-services-modal-section-title"><AppIcon name="sell" /> Listas y precios</div>
            </div>
          </b-col>
          <b-col md="5">
            <b-form-group label="Lista">
              <v-select :options="arr.select.listPrice" 
                        v-model="crud.formPrice.price_list_select" 
                        placeholder="Lista"
                        :disabled="crud.formPrice.id>0">
              </v-select>
            </b-form-group>
          </b-col>    
          <b-col md="4">
            <b-form-group label="Importe">
              <b-form-input type="number"
                            v-model="crud.formPrice.amount"
                            step="0.01"
                            placeholder="Ingresar el precio">
              </b-form-input>
            </b-form-group>            
          </b-col>
          <b-col md="3">                
            <b-button variant="dark" 
                      @click="saveFormPrice()"
                      title="Guardar Precio"
                      class="crud-services-button-save-price pull-right">
              <b-icon icon="plus" v-if="crud.formPrice.id==0"></b-icon>
              <i class="fa fa-save" v-else></i>
            </b-button> 
            <b-button variant="outline-danger" 
                      @click="cancelSaveFormPrice()"
                      title="Cancelar Edición"
                      class="crud-services-button-save-price pull-right mr-1"                      
                      v-if="crud.formPrice.id>0">
              <i class="fa fa-close"></i>
            </b-button>                                  
          </b-col>
          <b-col md="12">
            <b-table class="mb-0 app-table app-table--compact crud-services-table-prices"
                    responsive
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="tablePrices.items"
                    :fields="tablePrices.fields"                            
                    v-if="tablePrices.items.length">   

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 
              
              <template v-slot:cell(list)="data">                
                <div v-if="data.item.list">
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-services-list-prices-public">
                    (Pública)
                  </span>
                </div>
              </template>                                                
              
              <template v-slot:cell(price)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle" class="pull-right"
                            :disabled="crud.formPrice.id>0">
                  <template #button-content><AppIcon name="more_vert" /></template>
                  <b-dropdown-item @click="editPricesServices(data.item)">
                    <AppIcon name="edit" class="mr-1" /> Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="removePricesServices(data.item)">
                    <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <EmptyState v-else icon="payments" title="No se encontraron precios para este servicio" />
          </b-col> 
        </b-row>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formPrice.active=false">Cerrar</b-button>
        </div>
      </b-modal>

      <!-- CRUD TEMPLATE -->
      <b-modal v-model="modal.formTemplate.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close         
              size="xl"
              body-class="crud-services-template-body"
              :key="modal.formTemplate._id"
              :id="modal.formTemplate._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="description" /></span><h5 class="app-modal-header__title">{{ modal.formTemplate.title }}</h5></div></template>

        <b-row>
          <b-col lg="12">
            <div v-if="modal.formTemplate.service && modal.formTemplate.service.category" class="crud-services-template-service">
              <span class="crud-services-template-service__icon"><AppIcon name="design_services" /></span>
              <div><strong>{{ modal.formTemplate.service.name }}</strong><span>{{ modal.formTemplate.service.category.name }} <span v-if="modal.formTemplate.service.code">· {{ modal.formTemplate.service.code }}</span></span></div>
            </div>
          </b-col>          

          <b-col lg="12">
            <div class="crud-services-modal-section-title"><AppIcon name="article" /> Bloques de la plantilla</div>
          </b-col>        

          <b-col lg="12">
            <b-card no-body class="crud-services-template-workspace">
              <b-tabs pills card :vertical="!isMobileViewport" class="services-template-budget" active-nav-item-class="font-weight-bold text-uppercase text-dark">
                <b-tab v-for="(item, index) in modal.formTemplate.tabs"
                       :key="'dyn-tab-' + item.id" 
                       :title="item.reference">
                  <b-row class="crud-services-template-fields">
                    <b-col md="8">
                      <b-form-group label="Referencia" class="crud-services-template-field">
                        <b-form-input type="text"
                                      size="sm"
                                      v-model="item.reference"
                                      required
                                      placeholder="Ingresar una referencia">
                        </b-form-input>
                      </b-form-group>
                    </b-col>  
                    <b-col md="4" class="d-flex align-items-end justify-content-md-end mb-3">
                      <b-button-group size="sm" class="mr-1">
                        <b-button variant="outline-secondary"
                                  :disabled="index === 0"
                                  v-b-tooltip.hover
                                  title="Subir bloque"
                                  @click="moveTemplateTab(index, -1)">
                          <AppIcon name="arrow_upward" />
                        </b-button>
                        <b-button variant="outline-secondary"
                                  :disabled="index === modal.formTemplate.tabs.length - 1"
                                  v-b-tooltip.hover
                                  title="Bajar bloque"
                                  @click="moveTemplateTab(index, 1)">
                          <AppIcon name="arrow_downward" />
                        </b-button>
                      </b-button-group>
                      <b-button size="sm" variant="outline-danger" @click="closeTemplateTab(item)">
                        <AppIcon name="delete" class="mr-1" /> Quitar
                      </b-button>                      
                    </b-col>    
                  </b-row>
                  <b-row>                                      
                    <b-col md="12">
                      <b-form-group label="Título" class="crud-services-template-field">
                        <b-form-input type="text"
                                      size="sm"
                                      v-model="item.title"
                                      required
                                      placeholder="Ingresar un título">
                        </b-form-input>
                      </b-form-group>
                    </b-col>    

                    <b-col md="12">
                      <b-form-group label="Contenido" class="crud-services-template-field">
                        <vue-editor class="display-template-ql-editor" 
                                    v-model="item.description">
                        </vue-editor>              
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-tab>      
                
                <template #tabs-end>
                  <b-nav-item role="presentation" @click.prevent="newTemplateTab" href="#" title="Agregar nuevo bloque">
                    <AppIcon name="add" />
                  </b-nav-item>
                </template>   
                
                <template #empty>
                  <EmptyState icon="article" title="No hay bloques creados" description="Agregá un bloque desde el botón + de la barra de navegación." />
                </template>                                   
              </b-tabs>
            </b-card>            
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formTemplate.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveTemplate()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

  </div>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Param from '@/config/parameters'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import Function from '@/handler/funciones'  
  import { VueEditor } from "vue2-editor";
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      VueEditor,
      ModuleViewHeading,
      TabHeaderActions,
    },      
    data: () => {
      return {      
        access: {
          module_id: Modules.SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudServices',
          elements: {}
        }, 
        parameters: {
          integrateInstances: Helper.hasParametersAccess(Param.P59),          
        },                  
        table : {
          items: [],
          fields: [],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 0,
          isBusy: false,          
          tablePaginate: null,                
        },  
        tableERP : {
          items: [],
          fields: [],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 0,
          isBusy: false,          
          tablePaginate: null,                
        },          
        tablePrices : {
          items: [],
          fields: [
            {key: 'list', label: 'Lista', class:"align-middle", width:"250px"},
            {key: 'price', label: 'Precio', class:"align-middle", width:"100px"},
            {key: 'f_action', label:'', class:"align-middle", width:"100px"},
          ]
        },         
        crud: {
          form: {
            id: 0,
            name: '',  
            code: '',
            category: null,
            category_id: 0,
            mode: 'units',
            renewal: 0,
            active: true,
            automatic_renewal: false,
            mode_projects: '',
            erp_iva_condition: null,
            erp_iva_condition_id: 0,
            accounting_accounts: null,
            accounting_accounts_id: 0,
            type_instances: '',
            require_purchase_voucher: false,
            show_only_erp: false,
            display_sales_detail: '',
            observations: '',
          },  
          formPrice: {
            id: 0,
            services_id: 0,
            price_list_id: 0,
            price_list_select: null,
            amount: 0,
            amount_old: 0
          },                      
        },
        modal: {
          form: {
            active: false,
            title: ''
          },  
          formPrice: {
            active: false,
            title: ''
          },    
          formTemplate: {
            service: null,                        
            tabs: [],
            tabCounter: 0,
            active: false,
            title: ''           
          },                             
        },    
        arr: {
          services: [],            
          select: {
            // vinculación del servicio (se guarda en type_instances)
            linkTypes: [
              { value: '', text: 'No vincular' },
              { value: 'server', text: 'Vincular servidor' },
              { value: 'instance', text: 'Vincular instancia' },
            ],
            mode: [              
              { value: 'units', text: 'Unidad/es' },         
              { value: 'hours', text: 'Hora/s' },                                 
              { value: 'days', text: 'Día/s' },   
              { value: 'months', text: 'Mes/es' },   
              { value: 'years', text: 'Año/s' },   
            ],
            modeProjects: [
              { value: '', text: 'No crear proyecto' },   
              { value: 'with_expiration', text: 'Proyectos con Vencimiento' },   
              { value: 'without_expiration', text: 'Proyectos sin Vencimiento' },   
            ],
            listPrice: [],   
          },
          filter : {
            category: [],   
            status: [
              {code:true, label: 'Activo'},
              {code:false, label: 'Inactivo'},                                          
            ],
          }
        },
        filter : {
          category: [],          
          status: [
            {code:true, label: 'Activo'}            
          ],
          show_only_erp: false,
        },        
        modulesActive: [], 
        modules: {
          showPrices: false
        },    
        itemSelected: null,
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {    
      this.filtersOpen = StorageLocal.getValue('filters_open_services') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.modulesActive = Session.getSession().auth.user.permissions.modules
      this.configAccess()

      this.loadFieldTable()
      this.filterLoad()
      this.filterService()
      this.loadListPrice() 
      this._start = true
    },
    // la pestaña queda viva (keep-alive): al volver se recargan las categorías
    // del filtro, por si se agregaron desde Categorías mientras estaba abierta
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.filterLoadCategory()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_services', value ? 'true' : 'false')
      }
    },
    computed: {
      isProcessSales() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.VENTAS || element.id == Modules.PRESUPUESTOS) {
            status = true
          }
        })
        return status
      }, 
      isProcessAccounting() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },
      isProcessInstances(){
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.INSTANCIAS) {
            status = true
          }
        })
        return status && this.parameters.integrateInstances
      },
      isProcessProject(){
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.PROYECTOS) {
            status = true
          }
        })
        return status && this.parameters.integrateInstances
      },

      // CONDITIONS SELECT
      conditionAccountingAccountsFilters(){
          return [
              {field: 'active', condition: true},
              {field: 'type', condition: 'Ingresos'}
          ];
      },
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.loadFieldTable()
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      configAccess() {
        this.modulesActive.forEach(element => {          
          if(element.id == Modules.PRECIOS) {                          
            this.modules.showPrices = true                             
          }
        })
      },   
             
      loadFieldTable() {
        // EN SERVICIOS
        this.table.fields = []
        this.tableERP.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class:'align-middle ' + this.alignClass('text-center'), width:'4%'})
        this.table.fields.push({key: 'category', label: 'Categoría', class:'align-middle', width:'12%'})
        this.table.fields.push({key: 'name', label: 'Nombre', class:'align-middle', width:'30%'})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:'align-middle', width:'3%'})
        this.table.fields.push({key: 'mode', label: 'Medición', class:'align-middle ' + this.alignClass('text-center'), width:'8%'})
        this.table.fields.push({key: 'renewal', label: 'Renovación', class:'align-middle ' + this.alignClass('text-center'), width:'13%'})
        this.table.fields.push({key: 'prices', label: 'Precios', class:'align-middle ' + this.alignClass('text-center'), width:'14%'})

        if(this.isProcessProject) {
          this.table.fields.push({key: 'mode_projects', label: 'Proyecto', class:'align-middle ' + this.alignClass('text-center'), width:'6%'})
        }

        if(this.isProcessInstances) {
          this.table.fields.push({key: 'instances', label: 'Vinculación', class:'align-middle ' + this.alignClass('text-center'), width:'8%'})
        }

        this.table.fields.push({key: 'active', label: 'Estado', class:'align-middle ' + this.alignClass('text-center'), width:'6%'})
        this.table.fields.push({key: 'f_action', label:this.isMobileViewport ? 'Acción' : '', class: 'align-middle', width:'3%'})

        // SOLO ERP
        this.tableERP.fields.push({key: 'id', label: 'ID', sortable: true, class:'align-middle ' + this.alignClass('text-center'), width:'4%'})
        this.tableERP.fields.push({key: 'category', label: 'Categoría', class:'align-middle', width:'14%'})
        this.tableERP.fields.push({key: 'name', label: 'Nombre', class:'align-middle', width:'48%'})
        this.tableERP.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:'align-middle', width:'3%'})
                
        this.tableERP.fields.push({key: 'prices', label: 'Precios', class:'align-middle ' + this.alignClass('text-center'), width:'20%'})
       
        this.tableERP.fields.push({key: 'active', label: 'Estado', class:'align-middle ' + this.alignClass('text-center'), width:'8%'})
        this.tableERP.fields.push({key: 'f_action', label:this.isMobileViewport ? 'Acción' : '', class: 'align-middle', width:'3%'})
      },         
      filterService(forceOpenPrices=false){
        this.table.isBusy = true  
        this.filter.show_only_erp = false
        var result = serviceAPI.filtrarService(this.filter, this.table.currentPage)        
        result.then((response) => {        
          var data = response.data
          this.table.tablePaginate = data
                              
          this.table.items = data.data          

          this.table.items.forEach(element => {            
            if(forceOpenPrices) {
              if(element.id == this.itemSelected.id) {
                this.setPricesServices(element)
              }              
            }              
          }); 

          this.table.isBusy = false                    

          this.saveFilterStorage()
        })
        .catch(error => {          
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });   
        
        this.tableERP.isBusy = true  
        this.filter.show_only_erp = true
        var resultERP = serviceAPI.filtrarService(this.filter, this.tableERP.currentPage)        
        resultERP.then((responseERP) => {        
          var data = responseERP.data
          this.tableERP.tablePaginate = data
                              
          this.tableERP.items = data.data          

          this.tableERP.items.forEach(element => {            
            if(forceOpenPrices) {
              if(element.id == this.itemSelected.id) {
                this.setPricesServices(element)
              }              
            }              
          }); 

          this.tableERP.isBusy = false                    

          this.saveFilterStorage()
        })
        .catch(error => {          
          this.tableERP.isBusy = false
          this.$awn.alert(Error.showError(error))
        });           
      },       
      add() {
        this.crud.form.id = 0
        this.crud.form.code = '' 
        this.crud.form.name = '' 
        this.crud.form.category = null
        this.crud.form.category_id = 0
        this.crud.form.mode = 'units'
        this.crud.form.renewal = 0
        this.crud.form.active = true
        this.crud.form.automatic_renewal = false
        this.crud.form.mode_projects = ''
        this.crud.form.show_only_erp = false
        this.crud.form.display_sales_detail = ''

        this.crud.form.erp_iva_condition = null
        this.crud.form.erp_iva_condition_id = 0       

        this.crud.form.accounting_accounts = null
        this.crud.form.accounting_accounts_id = 0 

        this.crud.form.type_instances = ''
        this.crud.form.require_purchase_voucher = false

        this.crud.form.observations = ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Servicios"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.code = item.code
        this.crud.form.name = item.name                   
        this.crud.form.category = item.category
        this.crud.form.category_id = item.category_id
        this.crud.form.mode = item.mode
        this.crud.form.renewal = item.renewal
        this.crud.form.active = item.active
        this.crud.form.automatic_renewal = item.automatic_renewal
        this.crud.form.mode_projects = item.mode_projects
        this.crud.form.show_only_erp = item.show_only_erp
        this.crud.form.display_sales_detail = item.display_sales_detail

        this.crud.form.erp_iva_condition = item.erp_iva_condition
        this.crud.form.erp_iva_condition_id = item.erp_iva_condition_id
        
        this.crud.form.accounting_accounts = item.accounting_account
        this.crud.form.accounting_accounts_id = item.accounting_accounts_id  

        this.crud.form.type_instances = this.linkType(item)
        this.crud.form.require_purchase_voucher = !!item.require_purchase_voucher
        
        this.crud.form.observations = item.observations

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Servicios"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea eliminar el servicio “' + this.crud.form.name + '”?', {
          title: 'Eliminar servicio',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarServices(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()              
              this.filterService()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarServices(this.crud.form);
        } else {
          var result = serviceAPI.agregarServices(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()          
          this.filterService()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },   
      loadCategory (object) {
        if(object){
          this.crud.form.category = object
          this.crud.form.category_id = object.id                   
        } else {
          this.crud.form.category = null
          this.crud.form.category_id = 0
        }
      }, 
      changeMode(){        
        if(this.crud.form.mode != 'days' ||
           this.crud.form.mode != 'months' ||
           this.crud.form.mode != 'years') {

          this.crud.form.renewal = 0
          this.crud.form.automatic_renewal = false

        } 
      },  
      // vinculación del servicio: '' = no vincular, 'server' = servidor, 'instance' = instancia
      linkType(item) {
        return item && item.type_instances ? item.type_instances : ''
      },
      getModeName(mode) {
        switch (mode) {
          case 'units':
            return 'UNIDAD/ES'
            break;
          
          case 'hours':
            return 'HORA/S'
            break;

          case 'days':
            return 'DÍA/S'
            break;

          case 'months':
            return 'MES/ES'
            break;

          case 'years':
            return 'AÑO/S'
            break;            
        }
      },

      filterLoad() {
        this.filterLoadCategory()
        
        this.restoreFilterStorage() 
      },
      filterLoadCategory() {
        var result = serviceAPI.obtenerCategory()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.category = []
          data.forEach(element => {            
            this.arr.filter.category.push({ code: element.id, label: element.name })            
          });          
        })   
      },      

      loadListPrice() {
        var result = serviceAPI.obtenerListaPrecios()

        result.then((response) => {
          var data = response.data    

          data.forEach(element => {
            this.arr.select.listPrice.push({
              code: element.id,
              label: element.name
            })  
          });    
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error))
        });        
      },      
      setPricesServices(item) {
        this.crud.formPrice.id = 0
        this.crud.formPrice.services_id = item.id
        this.crud.formPrice.price_list_select = null
        this.crud.formPrice.price_list_id = null
        this.crud.formPrice.amount = 0
        this.crud.formPrice.amount_old = 0

        this.tablePrices.items = this.orderPriceListByUtility(item.prices)
        this.itemSelected = item

        this.modal.formPrice.active = true
        this.modal.formPrice.title = "Mantenimiento de Precios"
      },
      editPricesServices(item) {
        this.crud.formPrice.id = item.id
        this.crud.formPrice.services_id = item.services_id
        this.crud.formPrice.price_list_select = { code: item.list.id, label: item.list.name}
        this.crud.formPrice.price_list_id = item.list.id
        this.crud.formPrice.amount = item.amount_total      
        this.crud.formPrice.amount_old = item.amount_total
      },    
      cancelSaveFormPrice(){
        this.crud.formPrice.id = 0
        this.crud.formPrice.price_list_select = null
        this.crud.formPrice.price_list_id = null
        this.crud.formPrice.amount = 0
        this.crud.formPrice.amount_old = 0
      },
      removePricesServices(item) {
        var id = item.id
        var listName = 'LISTA: ' + item.list.name        
        var listAmount = 'PRECIO: ' + Intl.NumberFormat('es-AR',{style:'currency',currency:item.list.currency.code}).format(item.amount_total)

        this.confirmDialog('¿Desea eliminar el precio de ' + listName + ' con ' + listAmount + '?', {
          title: 'Eliminar precio',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.eliminarPrecio(id);

            result.then((response) => {      
              loader.hide()              
              this.filterService(true)
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          } 
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },
      saveFormPrice(){
        let loader = this.$loading.show();

        if(this.crud.formPrice.price_list_select) {
          this.crud.formPrice.price_list_id = this.crud.formPrice.price_list_select.code
        }        

        if (this.crud.formPrice.id) {
          var result = serviceAPI.editarPrecio(this.crud.formPrice)
        } else {
          var result = serviceAPI.agregarPrecio(this.crud.formPrice)
        }

        result.then((response) => {                         
          loader.hide()          
          this.filterService(true)
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },  
      orderPriceListByUtility(arrData) {
        let arrSort = arrData.map(item => {          
          return {
            ...item,
            utility: parseFloat(item.list.utility),
            currency_id: item.list.currency_id
          };
        });

        return Function.sortArrayIntegerMultiField(arrSort, ['currency_id','utility'], 1)
      },       
      
      loadIvaConditions (object) {
          if(object){
              this.crud.form.erp_iva_condition = object
              this.crud.form.erp_iva_condition_id = object.id             
          } else {
              this.crud.form.erp_iva_condition = null
              this.crud.form.erp_iva_condition_id = 0
          }
      },        
      loadAccountingAccounts (object) {
          if(object){
              this.crud.form.accounting_accounts = object
              this.crud.form.accounting_accounts_id = object.id             
          } else {
              this.crud.form.accounting_accounts = null
              this.crud.form.accounting_accounts_id = 0
          }
      },

      // PRESUPUESTOS
      setTemplate(item){
        this.modal.formTemplate.service = item
        
        this.modal.formTemplate.tabs = []
        this.modal.formTemplate.tabCounter = 0
        if(item.template_budget) {
          this.modal.formTemplate.tabs = JSON.parse(item.template_budget)
          this.modal.formTemplate.tabCounter = this.modal.formTemplate.tabs.length
        }

        this.modal.formTemplate._id = Math.random().toString(36).slice(2, 8)
        this.modal.formTemplate.active = true
        this.modal.formTemplate.title = "Plantillas para Presupuesto"
      },
      newTemplateTab() {
        this.modal.formTemplate.tabs.push({
          id: this.modal.formTemplate.tabCounter++,
          reference: "Bloque " + this.modal.formTemplate.tabCounter,
          title: '',
          description: '',
        })       
      },         
      moveTemplateTab(index, direction) {
        const targetIndex = index + direction
        const tabs = this.modal.formTemplate.tabs

        if(targetIndex < 0 || targetIndex >= tabs.length) {
          return false
        }

        const tab = tabs.splice(index, 1)[0]
        tabs.splice(targetIndex, 0, tab)
      },
      closeTemplateTab(item) {
        this.confirmDialog('¿Desea eliminar el bloque “' + item.reference + '”?', {
          title: 'Eliminar bloque',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {        
            for (let i = 0; i < this.modal.formTemplate.tabs.length; i++) {
              if (this.modal.formTemplate.tabs[i].id === item.id) {
                this.modal.formTemplate.tabs.splice(i, 1)
              }
            }
          } 
        })
        .catch(error => {               
          this.$awn.alert(Error.showError(error));
        })            
      },   
      saveTemplate() {
        this.confirmDialog('¿Guardar la plantilla de presupuesto para este servicio?', {
          title: 'Guardar plantilla',
          icon: 'save',
          okTitle: 'Guardar'
        })
        .then(value => {
          if (value) {                       
            let loader = this.$loading.show();            

            var template = JSON.stringify(this.modal.formTemplate.tabs)
            
            var result = serviceAPI.editarTemplateService({
              id: this.modal.formTemplate.service.id,
              template_budget: template,
            });
            
            result.then((response) => {
              this.modal.formTemplate.active = false
              loader.hide()
              this.filterService()
              this.$awn.success("Plantilla guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_services', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_services')) {
          this.filter = JSON.parse(Storage.getValue('filter_services'))
        }         
      },      
    }    
  }
</script>
<style>
  .crud-services-modal-body { padding: 16px 18px; }
  .crud-services-form-field,
  .crud-services-switch-field { background: var(--app-color-surface); border: 1px solid var(--app-color-border); border-radius: 7px; margin-bottom: 10px; padding: 10px 12px; }
  .crud-services-form-field legend,
  .crud-services-switch-field legend { color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); margin-bottom: 3px; }
  .crud-services-switch-field .form-text { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); margin-bottom: 7px; }
  .crud-services-switch-field .custom-control-label { color: var(--app-color-primary-active); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); }
  .crud-services-modal-section-title { align-items: center; border-top: 1px solid var(--app-color-border); color: var(--app-color-text); display: flex; font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); gap: 6px; margin: 6px 0 12px; padding-top: 14px; }
  .crud-services-modal-section-title .material-symbols-rounded { color: var(--app-color-primary); font-size: 18px; }
  .crud-table-service-code {
    font-size: 12px;
    font-weight: bold;  
  }
  .crud-services-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-services-code {
    color: gray;
  }  
  .crud-services-name { cursor: pointer; line-height: 1.35; }
  .crud-services-renewal { display: grid; gap: 4px; justify-items: center; }
  .crud-services-renewal__amount { color: var(--app-color-text); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); white-space: nowrap; }
  .crud-services-renewal__type,
  .crud-services-instance { align-items: center; border: 1px solid; border-radius: 999px; display: inline-flex; font-size: 11px; font-weight: var(--app-font-semibold); gap: 3px; line-height: 1; padding: 3px 6px; white-space: nowrap; }
  .crud-services-renewal__type .material-symbols-rounded,
  .crud-services-instance .material-symbols-rounded { font-size: 14px; }
  .crud-services-renewal__type--auto { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .crud-services-renewal__type--manual { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .crud-services-prices { display: grid; gap: 3px; text-align: left; }
  .crud-services-prices > div > div { align-items: baseline; display: flex; gap: 5px; justify-content: space-between; white-space: nowrap; }
  .crud-services-prices__list { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .crud-services-prices__more { color: var(--app-color-primary) !important; font-size: var(--app-text-xs) !important; padding: 0 !important; }
  .crud-services-instance--linkable { background: var(--app-color-primary-soft); border-color: var(--app-color-info-border); color: var(--app-color-primary-active); }
  .crud-services-instance--server { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .crud-services-renewal__voucher { align-items: center; color: var(--app-color-text-secondary); display: inline-flex; font-size: 11px; gap: 3px; margin-top: 3px; white-space: nowrap; }
  .crud-services-renewal__voucher .material-symbols-rounded { font-size: 14px; }
  .crud-services-template-body { background: var(--app-color-surface-subtle); padding: 16px 18px; }
  .crud-services-template-service { align-items: center; background: var(--app-color-surface); border: 1px solid var(--app-color-border); border-radius: 8px; display: flex; gap: 10px; padding: 10px 12px; }
  .crud-services-template-service__icon { align-items: center; background: var(--app-color-primary-soft); border-radius: 50%; color: var(--app-color-primary); display: inline-flex; height: 32px; justify-content: center; width: 32px; }
  .crud-services-template-service strong,
  .crud-services-template-service div > span { display: block; }
  .crud-services-template-service strong { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .crud-services-template-service div > span { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .crud-services-template-workspace { background: var(--app-color-surface); border-color: var(--app-color-border) !important; }
  .crud-services-template-field { margin-bottom: 12px; }
  .crud-services-template-field legend { color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); margin-bottom: 3px; }
  .crud-services-action-icon {
    color: #000 !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 18px;
  }       
  .crud-services-button-save-price {
    margin-top: 30px;
  }  
  .crud-services-list-prices-public {
    font-size: 10px;
    font-weight: 600;
    color: gray;
  }
  .crud-services-table-prices {
    min-height: 100px;
  }   
  .crud-services-legend-renewal {
    cursor: pointer;
  }
  .crud-services-table-project {
    cursor: pointer;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
<style>
  .display-template-ql-editor .ql-editor {
    min-height: 350px !important;
  }  
  .services-template-budget .nav-link:hover {
    text-decoration: underline;
  }
  .services-template-budget .nav { background: var(--app-color-surface-subtle); flex-wrap: nowrap; overflow-x: auto; }
  .services-template-budget.b-tabs:not(.b-tabs-card) .nav,
  .services-template-budget .nav.nav-pills { min-width: 210px; }
  .services-template-budget .tab-content { background: var(--app-color-surface); padding: 14px; }
  .popover-observations {
    cursor: pointer;
  }
  @media (max-width: 575.98px) {
    .crud-services-modal-body { padding: 14px; }
    .crud-services-template-body { padding: 14px; }
    .services-template-budget .nav { min-width: 0 !important; }
    .services-template-budget .tab-content { padding: 12px; }
    .crud-services-renewal { justify-items: start; }
    .crud-services-prices { max-width: none; }
  }
</style>
<style scoped>
  .btn.crud-services-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); padding: 0 !important; }
</style>
